import { render, staticRenderFns } from "./dubletten-confirmation-table-toolbar-base.vue?vue&type=template&id=f32466a0"
import script from "./dubletten-confirmation-table-toolbar-base.vue?vue&type=script&lang=js"
export * from "./dubletten-confirmation-table-toolbar-base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports